import { ModalService } from './modal.service';

import { Message } from '../../models';
import { TranslationConstants } from '../../constants/translation';

import { ConfirmationModalComponent } from '../../components/confirmation-modal/confirmation-modal.component';

export class ClosableModal {
  success: Function;
  confirmationModalTitle: string = TranslationConstants.GLOBAL_LEAVE;
  isSaveDisabled = false; // flag to make sure save is clicked only once

  constructor(protected modalService: ModalService) {}

  // must be public since it's used in template
  close(form = null, additionalCondition: boolean = false): void {
    if ((form && form.form.touched) || additionalCondition) {
      this.modalService.openModal({
        component: ConfirmationModalComponent,
        data: {
          title: this.confirmationModalTitle,
          content: TranslationConstants.GLOBAL_CANCEL_MODAL_MESSAGE,
        } as Message,
        success: () => {
          this.closeAllModals();
        },
      });
    } else {
      this.closeAllModals();
    }
  }

  protected closeAllModals(): void {
    this.modalService.closeModal(true);
  }
}
